import salekinds, { salekindNames } from '@constants/values/salekinds'

const rodzajSprzedazy = { t: 'Rodzaj sprzedaży', inputs: [
    { t: 'Sprzedaż', type: 'multi-checkbox', name: 'rodzaj-sprzedazy', options: salekinds.slice(0, 4), names: salekindNames.slice(0, 4)},
    { t: '', type: 'multi-checkbox', name: 'rodzaj-sprzedazy-', options: salekinds.slice(4), names: salekindNames.slice(4)}
]}

export default rodzajSprzedazy